import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_TelemedicineConsent = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_TelemedicineConsent' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'>
                    <h3>Telemedicine Consent Form</h3>
                </p>
                <p className='w-750'>
                    <ol>
                        <li>I authorize
                            <input type='text' id='txtClientName' name='txtClientName' className='add-only w-200 custom-add-only' />(Client Name) to allow me/the client to participate in a telemedicine (videoconferencing) service (via HIPAA compliant platform; Zoom) with Right Path Behavioral Health Services.</li>
                        <li>The type of service to be provided by via telemedicine is: Clinical Services/ Psychiatric Care/ Crisis Management. </li>
                        <li>I understand that this service is not the same as a direct client/healthcare provider visit, because I/the client will not be in the same room as the healthcare provider performing the service.  I understand that parts of my/the client's care and treatment which require examinations/ assessments may be conducted by providers and their staff at my/the client's location under the direction of the telemedicine healthcare provider.</li>
                        <li>My/the client's provider has fully explained to me the nature and purpose of the videoconferencing technology and has also informed me of expected risks, benefits and complications (from known and unknown causes), attendant discomforts and risks that may arise during the telemedicine session, as well as possible alternatives to the proposed sessions, including visits with a physician/ provider in-person.  The attendant risks of not using telemedicine sessions have also been discussed.  I have been given an opportunity to ask questions, and all of my questions have been answered fully and satisfactorily.</li>
                        <li>I understand that there are potential risks to the use of this technology, including but not limited to interruptions, unauthorized access by third parties, and technical difficulties. I am aware that either my/the client's healthcare provider or I can discontinue the telemedicine service if we believe that the videoconferencing connections are not adequate for the situation.</li>
                        <li>I understand that the telemedicine session will not be audio or video recorded at any time. </li>
                        <li>I agree to permit my/the client's healthcare information to be shared with other individuals for the purpose of scheduling. I acknowledge that if safety concerns mandate additional persons to be present, then my or guardian permission may not be needed.</li>
                        <li>I acknowledge that I have the right to request the following:
                            <ol type='a'>
                                <li>Omission of specific details of my/the client's clinical history/physical examination that are personally sensitive, or </li>
                                <li>Termination of the service at any time.</li>
                            </ol>


                        </li>
                        <li>When the telemedicine service is being used during an emergency, I understand that it is the responsibility of the telemedicine provider to advise my/the client's local healthcare provider regarding necessary care and treatment.  </li>
                        <li>It is the responsibility of the telemedicine provider to conclude the service upon termination of the videoconference connection.</li>
                        <li>I/the client understand(s) that my/the patient's insurance may be billed by telemedicine healthcare provider for telemedicine services.   </li>
                        <li>My/the client's consent to participate in this telemedicine service shall remain in effect for the duration of the specific service identified above, or until I revoke my consent in writing.</li>
                        <li>I/the client agree that there have been no guarantees or assurances made about the results of this service.</li>
                        <li>I/the client have been given the information to access the telemedicine website at http://zoom.us/ to review the services and have access to all information regarding telemedicine platform.</li>
                        <li>I confirm that I have read and fully understand the above. All blank spaces have been completed prior to my signing.  I have crossed out any paragraphs or words above which do not pertain to me.</li>


                    </ol>
                </p>

                
            </div>
        </form>

    )
}











